import _ from 'lodash'
import { PurchaseEvent } from '../../event'
import { sendToGA } from '../default/handle-purchase/send-to-ga'

export function handlePurchase(event: PurchaseEvent): void {
  sendToGA(event)
}
